"use strict";

(function (global) {

  /**
  * Предоставляет дополнительные методы для работы со ссылками на объекты.
  *
  * @mixin WebAccess.mixins.linkMixin
  * @since 5.0.0.7300
  */
  var linkMixin = {

    /**
    * Открыть ссылку в новом окне.
    *
    * @method WebAccess.mixins.linkMixin#open
    * @return {WebAccess.mixins.link} Объект типа link.
    */
    open: function () {
      var url = this.toURL();
      if (this.isNew) {
        url.setParam('mode', 'edit');
      };
      url.open();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    

    /**
    * Открыть ссылку в desktop-клиенте.
    *
    * @method WebAccess.mixins.linkMixin#openInDesktop
    * @return {WebAccess.mixins.link} Объект типа link.
    */
    openInDesktop: function () {
      var url = this.toURL();
      url.setParam('Desktop', 1);
      url.setParam('-view');
      url.open();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Преобразовать ссылку на объект в объект типа WA.URL.
    *
    * @method WebAccess.mixins.linkMixin#toURL
    * @return {WebAccess.URL} Объект типа URL.
    */
    toURL: function () {
      //TODO Шамов А.: Сломается везде, кроме Link, если использовать этот mixin в другом классе.
      //Шабардин П.: Да сломается, ну и что расширим URL, в нем для этого нет преград, а других объкетов мы пока не знаем, когда будем делать  - тогда и расширим.
      var url = new WA.URL(this);
      if (this.isNew) {
        url.setParam('mode', 'edit');
      };

      return url;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Преобразовать ссылку на объект в объект типа WebAccess.Models.Link, совместимый с серверной объекной моделью.
    *
    * @method WebAccess.mixins.linkMixin#toLinkModel
    * @return {Object} Объект типа WebAccess.Models.Link.
    */
    toLinkModel: function () {
      return {
        ID: this.id,
        Kind: objectTypeToString(this.type),
        CompCode: this.referenceName
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Преобразовать объект типа WebAccess.Models.Link в ссылку.
    *
    * @method WebAccess.mixins.linkMixin#toLinkModel
    * @return {Object} Ссылка на объект.
    */
    fromLinkModel: function (model) {
      if (!model) WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
      this.id = model.ID;
      this.type = objectKindToObjectType(model.Kind);
      this.referenceName = model.CompCode;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить строковое представление объекта.
     *
     * @method WebAccess.mixins.linkMixin#asString
     * @since 5.0.0.7300     
     * @return {string} Строковое представление объекта.
     */
    asString: function () {
      return $.toJSON({
        id: this.id,
        type: this.type,
        referenceName: this.referenceName
      });
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.linkMixin = linkMixin;
})(window.WebAccess.mixins);